export default __webpack_public_path__ + "static/media/icon.914981c6.png";